module.exports = __webpack_public_path__ + "static/img/kayran.d14b15a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/kayran.png
// module id = LjgZ
// module chunks = 0